import type { TrackingDisplayMode } from 'types/tracking.types';

interface TrackingModeToggleProps {
  mode: TrackingDisplayMode;
  onChange: (mode: TrackingDisplayMode) => void;
}

export default function TrackingModeToggle({
  mode,
  onChange,
}: TrackingModeToggleProps) {
  return (
    <div className="flex rounded-xl bg-slate-100 p-1 gap-1">
      <button
        type="button"
        onClick={() => onChange('map')}
        className={`flex-1 text-xs font-bold py-2 px-3 rounded-lg transition-colors ${
          mode === 'map'
            ? 'bg-white text-primary shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        Map
      </button>
      <button
        type="button"
        onClick={() => onChange('simple')}
        className={`flex-1 text-xs font-bold py-2 px-3 rounded-lg transition-colors ${
          mode === 'simple'
            ? 'bg-white text-primary shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        Route
      </button>
    </div>
  );
}
